import React, { Component, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Input, Button, ButtonGroup, 
         Modal, ModalHeader, ModalBody, Alert, Tooltip } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Control, Form } from 'react-redux-form';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { RenderInputTable } from './TableComponent';
import { toPerc, CustomListSelect, unique_values, latest_by_key } from './Functions';
import { port_optim_actions, port_optim_metrics_actions, port_optim_exposure_actions } from '../redux/ActionType';
import { postRequest, getRequest } from '../redux/ActionCreators';
import { CSVLink } from "react-csv";
import { field_options } from "../shared/data";
// import 'rsuite/dist/styles/rsuite-default.css';

const mapStateToProps = state => {
  return {
    assets_summ: state.assets_summ,
    asset_series: state.asset_series,
    optim_params: state.optim_params,
    optim_cons: state.optim_cons,
    optim_port_exposure:state.optim_port_exposure,
    optim_port_metrics:state.optim_port_metrics,
    user_wm: state.user_wm,
    optim_saa: state.optim_saa,
  };
};

class Params extends Component {
    constructor(props){
        super(props);
        this.state = {
            msg:null,
            msg_optim:null,
            msg_exp:null,
            msg_add:null,
            msg_assetcons:null,
            add_group_cons:false,
            group_id:"",
            fields_tooltip:{cv:false, regime:false, simulation:false},
            running_optim:false,
            saving_assetcons:false,
            importing_assetcons:false,
            modal_save_assetcons: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.buildFrontier = this.buildFrontier.bind(this);
        this.verifyStatus = this.verifyStatus.bind(this);
        this.updateAssetcons = this.updateAssetcons.bind(this); 
        this.toggleGroupCons = this.toggleGroupCons.bind(this); 
        this.addGroupCons = this.addGroupCons.bind(this); 
        this.resetGroupCons = this.resetGroupCons.bind(this); 
        this.saveAssetcons = this.saveAssetcons.bind(this); 
        this.importAssetcons = this.importAssetcons.bind(this); 
        this.toggleModalAssetcons = this.toggleModalAssetcons.bind(this);
    }
    componentDidMount(){
        if (this.props.assets_summ!==null){
            if (this.props.optim_cons.groupcons===null){
                this.props.changeModel('optim_cons.groupcons', [
                        {var:'AssetClass', name:'Renta Fija', lb:0, ub:100},
                        {var:'AssetClass', name:'Renta Variable', lb:0, ub:100},
                    ])
            }
            if (this.props.optim_cons.assetcons===null){
                this.props.changeModel('optim_cons.assetcons', this.props.assets_summ.map(item=>{
                    return {name:item.Id, ret:item['Retorno Esperado'], view:item['Retorno Esperado'], lb:0, ub:100}
                })
                );
            } else {
                console.log("update assetcons")
                this.props.changeModel('optim_cons.assetcons', this.props.assets_summ.map(item=>{
                    if (this.props.optim_cons.assetcons.map(k=>k.name).includes(item.Id)){
                        if (Math.abs(this.props.optim_cons.assetcons.find(k=>k.name===item.Id).ret - item['Retorno Esperado'])>0.01) {
                          return {...this.props.optim_cons.assetcons.find(k=>k.name===item.Id), ret:item['Retorno Esperado'], view:item['Retorno Esperado']};
                        } else {
                          return this.props.optim_cons.assetcons.find(k=>k.name===item.Id);
                        }
                        
                    }else{
                        return {name:item.Id, ret:item['Retorno Esperado'], view:item['Retorno Esperado'], lb:0, ub:100};
                    }
                }
                ));
            };
        }
    }
    // componentDidUpdate(prevProps) {
    // }
    toggleGroupCons(){
      this.setState({add_group_cons:!this.state.add_group_cons});
    }
    addGroupCons(){
      console.log("add group constraint");
      if(this.state.group_id==""){
        this.setState({msg_add:"Seleccionar variable"});
      }else if (this.state.value_id==""){
        this.setState({msg_add:"Seleccionar valor"});
      }else{
        const var_temp = field_options.find(k=>k.label==this.state.group_id).var;
        if (this.props.optim_cons.groupcons.filter(item=>item.var==var_temp & item.name==this.state.value_id).length>0){
          this.setState({msg_add:"Campo seleccionado ya existe en tabla de restricciones"});
        }else{
          this.props.changeModel('optim_cons.groupcons', [
                  ...this.props.optim_cons.groupcons,
                  {var:var_temp, name:this.state.value_id, lb:0, ub:100},
              ]);
        }
      }
    }
    resetGroupCons(){
      this.props.changeModel('optim_cons.groupcons', [
              {var:'AssetClass', name:'Renta Fija', lb:0, ub:100},
              {var:'AssetClass', name:'Renta Variable', lb:0, ub:100},
      ]);
      this.props.changeModel("optim_params.edit_tables", false);
    }
    async verifyStatus(){
      const port_optim_status = await getRequest({
          jobId: this.props.optim_params.job_id
      }, 'get_async_result', 3);

      let port_optim_resp = {success:false};
      console.log(port_optim_status);
      if (port_optim_status.status === "COMPLETED") {
          console.log("Optimization finished");
          this.props.updateState("ADD_SAA", port_optim_status.result);
          port_optim_resp = {success:true};
          this.props.changeModel("optim_params.job_id", null);
          this.setState({msg_optim:"Optimización por simulación ejecutada exitosamente."});
      }
      if (port_optim_status.status === "FAILED") {
          console.log("Optimization failed");
          this.props.changeModel("optim_params.job_id", null);
          this.setState({msg_optim:"Error ejecutando optimización por simulación. Intente de nuevo o verifique con el equipo de quantIM."});
      }
      if (["PENDING", "RUNNING"].includes(port_optim_status.status)) {
          console.log("Optimization running");
          this.setState({msg_optim:"Se está ejecutando optimización por simulación. Verifique el estado de nuevo en unos minutos."});
      }

      if (port_optim_resp?.success ){
          const optim_port_exp = await this.props.fetchData(
            { 
              port:this.props.optim_saa.data.port.map(x=>{
                return {name:x.name, value:x.w};
              }),
              bench:null,
            }, 'port_exposure_wm', port_optim_exposure_actions);
            
           if (optim_port_exp?.success){
              const optim_port_metrics = await this.props.fetchData(
                { 
                    ref_curr:this.props.optim_params.ref_curr,
                    port:this.props.optim_saa.data.port.map(x=>{
                        return {name:x.name, value:x.w};
                    }),
                    bench:this.props.optim_params.optim_type.slice(0,3)=="abs" ? null :this.props.optim_params.bench_name,
                    views: this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                        x=>{
                          return {name:x.name, value:x.view};
                        }),
                    ini_date:this.props.assets_summ[0]['Fecha Inicial']
                }, 'port_metrics_wm', port_optim_metrics_actions);
              if (optim_port_metrics?.success){
                  this.props.history.push(`/builder/optim/results`);
              }
           }
      } else {
          await this.props.resetModel('optim_port_exposure');
          await this.props.resetModel('optim_port_metrics');
      }

      
    }

    async buildFrontier(){
        const port_optim = await this.props.fetchData(
            {
                optim_params:{
                    ...this.props.optim_params,
                    ...(this.props.optim_params.robust_sol
                    ? { optim_strategy:this.props.optim_params.auto_reg_param ? "" : this.props.optim_params.optim_strategy, reg_param: this.props.optim_params.reg_param }   // keep original
                    : { optim_strategy: "", reg_param: 0 }               // reset if not robust
                    )
                }
                ,
                cons:this.props.optim_cons, 
                views:this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                    x=>{
                      return {name:x.name, value:x.view};
                    }),
                gen_frontier:true
            }, 'port_optim', port_optim_actions);
        if (port_optim?.success){
            await this.props.resetModel('optim_port_exposure');
            await this.props.changeModel('optim_params.frontier_ind', true);
            const optim_port_metrics = await this.props.fetchData(
              { 
                  ...this.props.optim_params,
                  quant:0.99,
                  port_names:null,
                  port_weights:this.props.optim_saa.data.port,
                  views: this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                    x=>{
                      return {name:x.name, value:x.view};
                    }),
              }, 'port_metrics_mult', port_optim_metrics_actions, 1, ["ports_exp", "rets_summ", "avail_dates", "names"]);
            if (optim_port_metrics?.success){
                this.props.history.push(`/builder/optim/results`);
            }
        } else {
            await this.props.resetModel('optim_port_metrics');
        }
    }

    async handleSubmit(){
        await this.props.resetModel('optim_params.frontier_ind', false);
        let port_optim_resp = {success:false};
        if (this.props.optim_params.robust_sol && this.props.optim_params.optim_strategy=="simulation"){
          console.log("simulation");
          this.setState({
            running_optim:true
          });
          let port_optim_async;
          try {
            port_optim_async = await postRequest({
              lambdaname:'port_optim',
              add_args:{
                optim_params:this.props.optim_params,
                cons:this.props.optim_cons, 
                views: this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                    x=>{
                      return {name:x.name, value:x.view};
                    }),
                other_params:{n_sample:200, m_simul:1000}
              }
            }, 'run_lambda', 3);
          } catch(error){
            this.setState({
              running_optim:false,
              msg_optim:error.msg
            });
            return;            
          }
          console.log(port_optim_async);
          if (port_optim_async.status=="ok"){
            const jobId = port_optim_async.jobId;
            this.props.changeModel("optim_params.job_id", jobId);
            this.props.changeModel("optim_params.job_status", "PENDING");
            const maxChecks = 6; // 6 * 20 sec = 120 sec
            console.log(jobId)
            for (let i = 0; i < maxChecks; i++) {

                console.log(`Checking status... attempt ${i + 1}`);
                // wait 20 sec
                await new Promise(resolve => setTimeout(resolve, 20000));
                // check job status
                const port_optim_status = await getRequest({
                    jobId: jobId
                }, 'get_async_result', 3);

                console.log(port_optim_status);
                if (port_optim_status.status === "COMPLETED") {
                    console.log("Optimization finished");
                    this.props.updateState("ADD_SAA", port_optim_status.result);
                    port_optim_resp = {success:true};
                    this.props.changeModel("optim_params.job_id", null);
                    this.setState({
                      msg_optim:"Optimización por simulación ejecutada exitosamente.",
                      running_optim:false
                    });
                    break;
                }
                if (port_optim_status.status === "FAILED") {
                    console.log("Optimization failed");
                    this.props.changeModel("optim_params.job_id", null);
                    this.setState({
                      msg_optim:port_optim_status?.msg || "Error ejecutando optimización por simulación. Intente de nuevo o verifique con el equipo de quantIM.",
                      running_optim:false
                    });
                    return;
                }
                // timeout reached
                if (i === maxChecks - 1) {
                    console.log("Timed out after 2 minutes");
                    this.setState({
                      msg_optim:"Optimización por simulación se continua ejecutando internamente. Verifique estado en unos segundos.",
                      running_optim:false
                    });
                    return;
                }
            }
          }
          this.setState({
            running_optim:false
          });
        } else {
          this.props.changeModel("optim_params.job_id", null);
          port_optim_resp = await this.props.fetchData(
              {
                  optim_params:{
                      ...this.props.optim_params,
                      ...(this.props.optim_params.robust_sol
                      ? { optim_strategy:this.props.optim_params.auto_reg_param ? "" : this.props.optim_params.optim_strategy, reg_param: this.props.optim_params.reg_param }   // keep original
                      : { optim_strategy: "", reg_param: 0 }               // reset if not robust
                      )
                  }
                  ,
                  cons:this.props.optim_cons, 
                  views: this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                      x=>{
                        return {name:x.name, value:x.view};
                      })
              }, 'port_optim', port_optim_actions, 3
          );
        }
        if (port_optim_resp?.success ){
            const optim_port_exp = await this.props.fetchData(
              { 
                port:this.props.optim_saa.data.port.map(x=>{
                  return {name:x.name, value:x.w};
                }),
                bench:null,
              }, 'port_exposure_wm', port_optim_exposure_actions);
              
             if (optim_port_exp?.success){
                const optim_port_metrics = await this.props.fetchData(
                  { 
                      ref_curr:this.props.optim_params.ref_curr,
                      port:this.props.optim_saa.data.port.map(x=>{
                          return {name:x.name, value:x.w};
                      }),
                      bench:this.props.optim_params.optim_type.slice(0,3)=="abs" ? null :this.props.optim_params.bench_name,
                      views: this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                          x=>{
                            return {name:x.name, value:x.view};
                          }),
                      ini_date:this.props.assets_summ[0]['Fecha Inicial']
                  }, 'port_metrics_wm', port_optim_metrics_actions);
                if (optim_port_metrics?.success){
                    this.props.history.push(`/builder/optim/results`);
                }
             }
        } else {
            await this.props.resetModel('optim_port_exposure');
            await this.props.resetModel('optim_port_metrics');
        }
    }
    
    updateAssetcons(update_type){
        console.log("update assetcons");
        if ((Number(this.props.optim_params.min_exp_per_asset ?? 0)>Number(this.props.optim_params.max_exp_per_asset ?? 100)) || Number(this.props.optim_params.min_exp_per_asset ?? 0)<-1e-5 || Number(this.props.optim_params.max_exp_per_asset ?? 100)>100){
          this.setState({msg:"No se pueden actualizar límites de exposición"});
        }else if (update_type=="min"){
          this.props.changeModel('optim_cons.assetcons', this.props.optim_cons.assetcons.map(item=>{
            return {...item, lb:Math.max(item.lb, this.props.optim_params.min_exp_per_asset)};
          }));
        }else if (update_type=="max"){
          this.props.changeModel('optim_cons.assetcons', this.props.optim_cons.assetcons.map(item=>{
            return {...item, ub:Math.min(item.ub, this.props.optim_params.max_exp_per_asset)};
          }));
        }else if (update_type=="reset"){
          this.props.changeModel('optim_cons.assetcons', this.props.optim_cons.assetcons.map(item=>{
            return {...item, lb:0, ub:100};
          }));
          this.props.changeModel('optim_params.min_exp_per_asset', 0);
          this.props.changeModel('optim_params.max_exp_per_asset', 100);
        }
    }

    async importAssetcons(){
      if (!this.props.optim_params.ref_port_assets){
        this.setState({msg_assetcons:"No se ha seleccionado portafolio en la hoja de inicial de selección de activos."});             
      }else{
        this.setState({importing_assetcons:true});
        try {
          console.log("import");
          const assetcons_in_db = await postRequest({
            prefix:'inputs/benchmarks/constraints/optimization',
            bucket:"condor-sura", 
            key:`inputs/benchmarks/constraints/optimization/${this.props.optim_params.ref_port_assets}/assets/cons.csv`, 
            sep:',',
          }, 'retrieve_data_s3');
          if (assetcons_in_db?.status){
            this.setState({
              msg_assetcons:assetcons_in_db.msg
            });
          }else{
            const assetcons_prev = latest_by_key(assetcons_in_db, 'name', 'timeStamp');
            const assetcons_udt = [...this.props.optim_cons.assetcons].map(item=>{
              const item_prev = assetcons_prev.find(k=>k.name==item.name);
              if (item_prev && (Math.abs(item_prev.lb-item.lb)>0.01 || Math.abs(item_prev.ub-item.ub)>0.01 || (item_prev.view!=="" && Math.abs(item_prev.view-item.view)>0.01))){
                return {...item, view:item_prev.view!=="" ? item_prev.view : item.view, lb:item_prev.lb, ub:item_prev.ub};
              }else{
                return {...item};
              }
            });
            await this.props.changeModel("optim_cons.assetcons", assetcons_udt);
            await this.props.changeModel("optim_params.edit_tables", false);
            this.setState({
              msg_assetcons:"Se han importado restricciones guardadas."
            });
          }
          this.setState({
            importing_assetcons:false,
          })
        } catch(error) {
          this.setState({
            importing_assetcons:false,
            msg_assetcons:`Error (${error.message})`
          });
        }
      }
    }

    toggleModalAssetcons(){
      if (!this.props.optim_params.ref_port_assets){
        this.setState({msg_assetcons:"No se ha seleccionado portafolio en la hoja de inicial de selección de activos."});             
      }else{
        this.setState({modal_save_assetcons:true});
      }
    }

    async saveAssetcons(){
      this.setState({
        saving_assetcons:true,
        modal_save_assetcons:false
      });
      // First: try to import
      let assetcons_filtered = null;
      try {
        console.log("import");
        const assetcons_in_db = await postRequest({
          prefix:'inputs/benchmarks/constraints/optimization',
          bucket:"condor-sura", 
          key:`inputs/benchmarks/constraints/optimization/${this.props.optim_params.ref_port_assets}/assets/cons.csv`, 
          sep:',',
        }, 'retrieve_data_s3');
        if (!assetcons_in_db?.status){
          const assetcons_prev = latest_by_key(assetcons_in_db, 'name', 'timeStamp');
          assetcons_filtered = [...this.props.optim_cons.assetcons].map(item=>{
            const item_prev = assetcons_prev.find(k=>k.name==item.name);
            if (item_prev && (Math.abs(item_prev.lb-item.lb)>0.01 || Math.abs(item_prev.ub-item.ub)>0.01 || (item_prev.view!=="" && Math.abs(item_prev.view-item.view)>0.01))){
              return {timeStamp:new Date(Date.now()).toISOString(), portId:this.props.optim_params.ref_port_assets, name:item.name, view:item.view, lb:item.lb, ub:item.ub};
            }else{
              return null;
            }
          }).filter(item => item !== null);
        } else {
          assetcons_filtered = [...this.props.optim_cons.assetcons].map(item=>{
            return {timeStamp:new Date(Date.now()).toISOString(), name:item.name, view:item.view, lb:item.lb, ub:item.ub};
          });
        }
      } catch(error) {
        console.log("Cannot retrieve previous constraints");
        assetcons_filtered = [...this.props.optim_cons.assetcons];
      }
      console.log(assetcons_filtered);
      try {
        if (assetcons_filtered && assetcons_filtered.length>0){
          console.log(              { 
              prefix:'inputs/benchmarks/constraints/optimization',
              append_type:'save',
              bucket:"condor-sura", 
              key:`inputs/benchmarks/constraints/optimization/${this.props.optim_params.ref_port_assets}/assets/cons.csv`, 
              sep:',',
              new_data:assetcons_filtered
            })
          const resp_append = await postRequest(
            { 
              prefix:'inputs/benchmarks/constraints/optimization',
              append_type:'save',
              bucket:"condor-sura", 
              key:`inputs/benchmarks/constraints/optimization/${this.props.optim_params.ref_port_assets}/assets/cons.csv`, 
              sep:',',
              new_data:assetcons_filtered
            }, 'append_data');
          if (resp_append.status=='ok'){
            this.setState({msg_assetcons:"Nuevas restricciones han sido guardadas."});
          }else {
            this.setState({msg_assetcons:"No se guardaron las nuevas restricciones. Intente de nuevo."});
          }
        }else{
          this.setState({
            msg_assetcons:"No se han creado/modificado nuevas restricciones"
          });
        }
        this.setState({saving_assetcons:false});

      } catch(error) {
        this.setState({
          saving_assetcons:false,
          msg_assetcons:`Error (${error.message})`
        });
      }
    }

    render(){
        if(this.props.user_wm.isLogging){
            return(
              <div className='container'>
                <div className="row justify-content-center">
                    <Logging />
                </div>
              </div>
            );
        } else if(this.props.optim_saa.isLoading){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Optimización</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                      <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                      <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                      <BreadcrumbItem><Link to='/builder/optim/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <CustomLoading msg="optimizando portafolio" icon="fa-star"/>
                </div>
              </div>
          );
        } else if(this.props.optim_port_exposure.isLoading){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Optimización</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                      <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                      <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                      <BreadcrumbItem><Link to='/builder/optim/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <CustomLoading msg="calculando exposición" icon="fa-compass"/>
                </div>
              </div>
          );
        } else if(this.props.optim_port_metrics.isLoading){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Optimización</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                      <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                      <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                      <BreadcrumbItem><Link to='/builder/optim/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
                </div>
              </div>
          );
        } else if (this.props.assets_summ==null) {
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Optimización</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                      <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                      <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                      <BreadcrumbItem><Link to='/builder/optim/results'>Resultados</Link></BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center m-5">
                  <h6>No se han seleccionado activos</h6>
                </div>
              </div>
          );
        } else {
            this.props.changeModel("optim_params.date_ini", this.props.assets_summ!==null ? this.props.assets_summ[0]['Fecha Inicial']:'2014-01-01');
            this.props.changeModel("optim_params.date_ref", this.props.assets_summ!==null ? this.props.assets_summ[0]['Fecha Final'] : (new Date()).toISOString().slice(0,10));
            return(
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-auto">
                            <h4>Optimización</h4>
                        </div>
                    </div>
                    <div className="row m-3 justify-content-center">
                      <div className="col-auto">
                        <Breadcrumb>
                          <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                          <BreadcrumbItem active>Parámetros</BreadcrumbItem>
                          <BreadcrumbItem><Link to='/builder/optim/results'>Resultados</Link></BreadcrumbItem>
                        </Breadcrumb>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-9">
                            <Form model="optim_params" onSubmit={this.handleSubmit}>
                                <div className="row justify-content-center">
                                    <div className="col-12 m-3">
                                        <h5><center>Política de Inversión</center></h5>
                                    </div>
                                </div>
                                <div className="row mt-2 justify-content-center">
                                    <div className="col-4">
                                      <Alert
                                        color='danger'
                                        isOpen={this.state.msg!==null}
                                        toggle={()=>this.setState({msg:null})}
                                        fade={false}>
                                          {this.state.msg}
                                      </Alert>
                                    </div>
                                </div>
                                <div className="row mt-2 justify-content-center">
                                    <div className="col-4">
                                      <Alert
                                        color='danger'
                                        isOpen={this.props.optim_saa.errMess!==null}
                                        toggle={()=>this.props.resetErr(port_optim_actions.reset_err)}
                                        fade={false}>
                                          {this.props.optim_saa.errMess}
                                      </Alert>
                                    </div>
                                </div>
                                <div className="row mt-2 justify-content-center">
                                    <div className="col-4">
                                      <Alert
                                        color='secondary'
                                        isOpen={this.props.optim_port_exposure.errMess!==null}
                                        toggle={()=>this.props.resetErr(port_optim_exposure_actions.reset_err)}
                                        fade={false}>
                                          {this.props.optim_port_exposure.errMess}
                                      </Alert>
                                    </div>
                                </div>
                                <div className="row mt-2 justify-content-center">
                                    <div className="col-4">
                                      <Alert
                                        color='secondary'
                                        isOpen={this.props.optim_port_metrics.errMess!==null}
                                        toggle={()=>this.props.resetErr(port_optim_metrics_actions.reset_err)}
                                        fade={false}>
                                          {this.props.optim_port_metrics.errMess}
                                      </Alert>
                                    </div>
                                </div>
                                <div className="row mt-2 justify-content-center">
                                    <div className="col-4">
                                      <Alert
                                        color='secondary'
                                        isOpen={this.props.optim_port_exposure.errMess!==null}
                                        toggle={()=>this.props.resetErr(port_optim_exposure_actions.reset_err)}
                                        fade={false}>
                                          {this.props.optim_port_exposure.errMess}
                                      </Alert>
                                    </div>
                                </div>

                                <div className='row m-3 justify-content-center align-items-end'>
                                    <div className='col-2'>
                                        <label htmlFor=".optim_type"><small>Asignación Objetivo</small></label>
                                        <Control.select model=".optim_type" type="select" name="optim_type"
                                            className="form-control">
                                            <option value="absolute">Absoluta</option>
                                            <option value="relative">Relativa</option>
                                        </Control.select>
                                    </div>
                                    <div className='col-2'>
                                        <label htmlFor=".date_ini"><small>Fecha Inicial</small></label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            this.props.assets_summ !== null
                                              ? this.props.assets_summ[0]['Fecha Inicial']
                                              : '2014-01-01'
                                          }
                                          readOnly
                                        />                                        
                                    </div>
                                    <div className='col-2'>
                                        <label htmlFor=".date_ref"><small>Fecha Final</small></label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={this.props.assets_summ!==null ? this.props.assets_summ[0]['Fecha Final'] : (new Date()).toISOString().slice(0,10)}
                                          readOnly
                                        />
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-3'>
                                    {this.props.optim_params.optim_type=="relative" ?
                                    <>
                                        <div className='col-4'>
                                            <label htmlFor=".bench_name"><small>Benchmark</small></label>
                                            <CustomListSelect
                                                options={this.props.user_wm.data.ports_list}
                                                isClearable={true}
                                                value={{value:this.props.optim_params.bench_name, label:this.props.optim_params.bench_name}}
                                                onChange={(e) => this.props.changeModel("optim_params.bench_name", e?.value)}
                                                itemSize={40}
                                                className="basic-single"
                                                placeholder="benchmark"
                                                fontSize={15}
                                            />
                                        </div>
                                        <div className='col-2'>
                                            <label htmlFor=".max_dev"><small>Máx. Desv. vs. Benchmark</small></label>
                                            <Control 
                                                model=".max_dev"
                                                type="number" name="max_dev"
                                                className="form-control"
                                                updateOn='blur'
                                                onBlur={() => setTimeout(() => this.updateAssetcons("dev"), 0)}
                                                disabled={this.props.optim_params.optim_type=="absolute"}
                                                />
                                        </div>
                                    </>
                                    :null
                                    }
                                </div>
                                <div className='row justify-content-center align-items-end m-3'>
                                    <div className='col-2'>
                                        <label htmlFor=".min_ret"><small>Retorno Mínimo (%)</small></label>
                                        <Control 
                                            model=".min_ret" 
                                            type="number"
                                            name="min_ret"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={this.props.optim_params.max_risk!=='' || (this.props.optim_params.min_te && this.props.optim_params.optim_type=="relative") || (this.props.optim_params.optim_type=="absolute" && this.props.optim_params.max_sharpe)}
                                            />
                                    </div>
                                    <div className='col-2'>
                                      <Control.checkbox model=".max_sharpe"
                                          className="form-check-input"
                                          disabled={this.props.optim_params.optim_type=="relative"}/>
                                          <small>{"         "}Maximizar Sharpe</small>
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-3'>
                                    <div className='col-2'>
                                        <label htmlFor=".max_risk"><small>{this.props.optim_params.optim_type=="absolute" ? "Riesgo Máximo (%)" : "TE Máximo (%)"}</small></label>
                                        <Control 
                                            model=".max_risk"
                                            type="number" name="max_risk"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={this.props.optim_params.min_ret!=='' || (this.props.optim_params.min_te && this.props.optim_params.optim_type=="relative") || (this.props.optim_params.optim_type=="absolute" && this.props.optim_params.max_sharpe)}
                                            />
                                    </div>
                                    <div className='col-2'>
                                      <Control.checkbox model=".min_te"
                                          className="form-check-input"
                                          disabled={this.props.optim_params.optim_type=="absolute"}                                        />
                                          <small>{"         "}Minimizar TE</small>
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-3'>
                                    <div className='col-2'>
                                        <label htmlFor=".target_dur"><small>Target Duración</small></label>
                                        <Control 
                                            model=".target_dur" 
                                            type="number"
                                            name="target_dur"
                                            className="form-control"
                                            updateOn='blur'
                                            />
                                    </div>
                                    <div className='col-2'>
                                        <label htmlFor=".dur_interv"><small>Desviación Duración</small></label>
                                        <Control 
                                            model=".dur_interv" 
                                            type="number"
                                            name="dur_interv"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={this.props.optim_params.target_dur==''}
                                        />
                                    </div>
                                </div>
                                <div className='row justify-content-center align-items-end m-3'>
                                    <div className='col-2'>
                                        <label htmlFor=".min_exp_per_asset"><small>Mínimo % por activo</small></label>
                                        <Control 
                                            model=".min_exp_per_asset" 
                                            type="number"
                                            name="min_exp_per_asset"
                                            className="form-control"
                                            updateOn='blur'
                                            onBlur={() => setTimeout(() => this.updateAssetcons("min"), 0)}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <label htmlFor=".max_exp_per_asset"><small>Máximo % por activo</small></label>
                                        <Control 
                                            model=".max_exp_per_asset" 
                                            type="number"
                                            name="max_exp_per_asset"
                                            className="form-control"
                                            updateOn='blur'
                                            onBlur={() => setTimeout(() => this.updateAssetcons("max"), 0)}
                                        />
                                    </div>
                                    <div className='col-auto'>
                                        <Button
                                          className="link-btn"
                                          onClick={() => this.updateAssetcons("reset")}
                                        >reset &#9733;</Button>
                                    </div>

                                </div>
                                {/*
                                <div className='row justify-content-center align-items-center m-3'>
                                    <div className='col-3'>
                                      <Control.checkbox model=".fx_hist_rate"
                                          className="form-check-input"/>
                                          <small>{'  '}Devaluación Histórica</small>
                                    </div>
                                    <div className='col-3'>
                                        <label htmlFor=".fx_exp_rate"><small>Devaluación Esperada USD</small></label>
                                        <Control.text model=".fx_exp_rate"
                                            type="number" 
                                            name="fx_exp_rate"
                                            className="form-control"
                                            updateOn='blur'
                                            disabled={this.props.optim_params.fx_hist_rate}
                                        />
                                    </div>
                                </div>
                                    
                                */}
                                <div className='row justify-content-center align-items-end m-3'>
                                    <div className='col-2'>
                                            <Control.checkbox 
                                                model=".robust_sol"
                                                className="form-check-input"
                                            />
                                            <small>{'   '}Solución Robusta</small>
                                    </div>
                                </div>
                                {this.props.optim_params.robust_sol ?
                                <div className='row justify-content-center align-items-end m-3'>
                                    <div className='col-3'>
                                            <Control.checkbox 
                                                model=".auto_reg_param"
                                                className="form-check-input"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                      this.props.changeModel("optim_params.optim_strategy", null)                                                    }
                                                }}
                                            />
                                            <small>{'   '}Ajustar Diversificación Manualmente</small>
                                    </div>
                                    {this.props.optim_params.auto_reg_param ?
                                    <>
                                        <div className="col-3">
                                            <label htmlFor=".reg_param"><small>Nivel Diversificación</small></label>
                                            <Input
                                              type="range"
                                              min="0"
                                              max="100"
                                              value={this.props.optim_params.reg_param*1000}
                                              disabled={!this.props.optim_params.auto_reg_param}
                                              onChange={(e) => {
                                                  this.props.changeModel("optim_params.reg_param", e.target.value/1000);
                                                }
                                              }
                                              className="slider"
                                              style={{ "--val": this.props.optim_params.reg_param*1000 }}
                                            />
                                        </div>
                                        <div className="col-1">
                                            <small>{toPerc(this.props.optim_params.reg_param*1000)}</small>
                                        </div>
                                    </>
                                    :
                                    <div className='col-3'>
                                        <ButtonGroup size='sm'>
                                          <Button
                                            color="dark"
                                            outline
                                            onClick={() => this.props.changeModel("optim_params.optim_strategy", 'cv')}
                                            active={this.props.optim_params.optim_strategy=='cv'}
                                          >
                                            <span href="#" id="cv"><small>Diversificar</small></span>
                                          </Button>
                                          <Button
                                            color="dark"
                                            outline
                                            onClick={() => this.props.changeModel("optim_params.optim_strategy", 'regime')}
                                            active={this.props.optim_params.optim_strategy=='regime'}
                                          >
                                            <span href="#" id="regime"><small>Escenarios</small></span>
                                          </Button>
                                          <Button
                                            color="dark"
                                            outline
                                            onClick={() => this.props.changeModel("optim_params.optim_strategy", 'simulation')}
                                            active={this.props.optim_params.optim_strategy=='simulation'}
                                            disabled={!(this.props.user_wm.data.services.includes("run_lambda") || this.props.user_wm.data.role==1)}
                                          >
                                            <span href="#" id="simulation"><small>Simulación/Resampling</small></span>

                                          </Button>
                                        </ButtonGroup>
                                        <Tooltip
                                              hideArrow={false} placement="top"
                                              modifiers={[{name: 'offset',options: {offset: [50, 15]}}]}
                                              isOpen={this.state.fields_tooltip.cv} 
                                              target="cv" toggle={()=>this.setState({fields_tooltip:{...this.state.fields_tooltip, cv:!this.state.fields_tooltip.cv}})}
                                        >
                                          <p><small>Esta opción utiliza validación cruzada para estimar automáticamente un parámetro de regularización a partir de datos históricos. El parámetro se incorpora en la optimización junto con los retornos esperados o views definidos por el usuario.</small></p> 
                                        </Tooltip>
                                        <Tooltip
                                              hideArrow={false} placement="top"
                                              modifiers={[{name: 'offset',options: {offset: [50, 15]}}]}
                                              isOpen={this.state.fields_tooltip.regime} 
                                              target="regime" toggle={()=>this.setState({fields_tooltip:{...this.state.fields_tooltip, regime:!this.state.fields_tooltip.regime}})}
                                        >
                                          <p><small>Esta opción identifica tres regímenes de mercado a partir de datos históricos mediante un modelo HMM y estima la probabilidad de ocurrencia de cada uno. Los regímenes con mayor presencia histórica reciben una mayor probabilidad. Los views o retornos esperados no se incorporan en la optimización.</small></p> 
                                        </Tooltip>
                                        <Tooltip
                                              hideArrow={false} placement="top"
                                              modifiers={[{name: 'offset',options: {offset: [50, 15]}}]}
                                              isOpen={this.state.fields_tooltip.simulation} 
                                              target="simulation" toggle={()=>this.setState({fields_tooltip:{...this.state.fields_tooltip, simulation:!this.state.fields_tooltip.simulation}})}
                                        >
                                          <p><small>Esta alternativa simula escenarios de retorno a partir de distribuciones estimadas para los activos. Cuando existen views o retornos esperados, se construye una única distribución multivariada para generar escenarios, optimizar portafolios sobre cada uno y promediar los resultados. En ausencia de views, las distribuciones se estiman utilizando al menos tres particiones de los datos históricos.</small></p> 
                                        </Tooltip>
                                    </div>

                                    }    
                                </div>
                                : null
                                }
                                <div className='row justify-content-center m-3'>
                                    {/*
                                    <div className='col-2'>
                                          <Control.checkbox 
                                            model=".views_saa"
                                            className="form-check-input"
                                            disabled={true}
                                            />
                                          <small>{'   '}Incorporar views estratégicos</small>
                                    </div>
                                    */}
                                </div>
                                <div className="row justify-content-center mt-5">
                                    {this.state.running_optim ?
                                    <div className='col-3'>
                                      <CustomLoading msg="optimizando por simulación" icon="fa-star" mt="0" />
                                    </div>
                                    :
                                    <>
                                      <div className='col-auto'>
                                          <Button type="submit" className="btn-corp">
                                              Optimizar Portafolios
                                          </Button>
                                      </div>
                                      <div className='col-auto'>
                                          <Button 
                                              className="btn-corp"
                                              onClick={this.buildFrontier}
                                              >
                                              Generar Frontera
                                          </Button>
                                      </div>
                                      {this.props.optim_params.job_id ?
                                        <div className='col-auto'>
                                            <Button 
                                                className="btn-corp"
                                                onClick={this.verifyStatus}
                                                >
                                                Verificar Estatus Optimización
                                            </Button>
                                        </div>
                                      :null
                                      }  
                                    </>
                                    }
                                </div>
                                <div className="row mt-2 justify-content-center">
                                  <div className="col-6 m-3">
                                    <Alert
                                      color='secondary'
                                      isOpen={this.state.msg_optim!=='' && this.state.msg_optim!==null} 
                                      toggle={()=>this.setState({msg_optim:null})}>
                                        {this.state.msg_optim}
                                    </Alert>
                                  </div>
                                </div>
                                <div className="row m-3 justify-content-center">
                                    <div className='col-2'>
                                          <Control.checkbox model=".edit_tables"
                                            id=".edit_tables"
                                            className="form-check-input"/>
                                            <small>{'  '}Editar Tablas</small>
                                    </div>
                                    <div className='col-2'>
                                          <Control.checkbox model=".random_views"
                                              className="form-check-input"/>
                                          <small>{'   '}Views aleatorios</small>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6 mt-3 d-flex flex-column align-items-end">
                          <div className="col-auto">
                            <RenderInputTable 
                                model_id={'optim_cons'}
                                model={this.props.optim_cons}
                                element_id='assetcons'
                                columns={['Activo','Retorno', 'View', 'Lím. Inf.', 'Lím. Sup.']}
                                keys={['ret','view','lb','ub']}
                                changeModel={this.props.changeModel}
                                edit={this.props.optim_params.edit_tables}
                                fontsize={12}
                                editable={[false,true,true,true]}
                                to_perc={[true, true, true, true]}
                                style={"black"}
                                />
                            <div className="row justify-content-center align-items-end mt-1">
                              {this.state.importing_assetcons ?
                                <div className='col-12 mt-0'>
                                  <CustomLoading msg="importanto restricciones" icon="fa-compass" />
                                </div>
                              :
                                <div className='col-auto mt-0'>
                                  <Button
                                    size="sm"
                                    className="link-btn"
                                    onClick={this.importAssetcons}
                                  >
                                    importar&darr;
                                  </Button>
                                </div>
                              }
                              {this.state.saving_assetcons ?
                                <div className='col-12 mt-0'>
                                  <CustomLoading msg="guardando restricciones" icon="fa-database" />
                                </div>
                              :
                                <div className='col-auto mt-0'>
                                  <Button
                                    size="sm"
                                    className="link-btn"
                                    onClick={this.toggleModalAssetcons}
                                  >
                                    guardar&uarr;
                                  </Button>
                                </div>
                              }
                              <div className="col-auto m-1">
                                <CSVLink className='link-btn' data={this.props.optim_cons.assetcons || []} filename="constraints"><small>descargar&darr;</small></CSVLink>
                              </div>
                            </div>
                            <div className="row justify-content-center align-items-end mt-1">
                              <div className="col m-3">
                                <Alert
                                  color='secondary'
                                  isOpen={this.state.msg_assetcons!=='' && this.state.msg_assetcons!==null} 
                                  toggle={()=>this.setState({msg_assetcons:null})}>
                                    {this.state.msg_assetcons}
                                </Alert>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Modal isOpen={this.state.modal_save_assetcons} toggle={()=>this.setState({modal_save_assetcons:!this.state.modal_save_assetcons})}>
                          <ModalHeader toggle={()=>this.setState({modal_save_assetcons:!this.state.modal_save_assetcons})}>Guardar Restricciones por Activo</ModalHeader>
                          <ModalBody>
                            <div className="row m-1 justify-content-center">
                              <h6>Se van a guardar restricciones asociadas al portafolio {this.props.optim_params.ref_port_assets}. ¿Estás de acuerdo?</h6>
                              <p>Si estás creando un nuevo portafolio que debe tener estar restricciones, primero crealo con el nombre que corresponda, y posteriormente vuelves a esta sección para guardar sus restricciones. </p>
                            </div>
                            <div className="row m-1 justify-content-center">
                              <div className="col-auto m-1">
                                <Button 
                                  onClick={this.saveAssetcons}
                                  className="btn-corp">
                                    Sí, guardar
                                </Button>
                              </div>
                              <div className="col-auto m-1">
                                <Button 
                                  onClick={()=>this.setState({modal_save_assetcons:false})}
                                  className="btn-corp">
                                    No, déjame validar
                                </Button>
                              </div>
                            </div>
                          </ModalBody>  
                        </Modal>

                        <div className="col-md-6 mt-3 d-flex flex-column align-items-start">
                            <div className="row mt-0 justify-content-start">
                                <div className="col-auto">
                                    <RenderInputTable model_id={'optim_cons'}
                                        model={this.props.optim_cons}
                                        element_id='groupcons'
                                        columns={['Grupo','Lím. Inf.', 'Lím. Sup.']}
                                        keys={['lb','ub']}
                                        changeModel={this.props.changeModel}
                                        edit={this.props.optim_params.edit_tables}
                                        fontsize={12}
                                        editable={[true,true,true]}
                                        to_perc={[true, true]}
                                        style={"black"}
                                        />
                                      <Button 
                                        onClick={this.toggleGroupCons}
                                        className="link-btn">
                                          <small>agregar restricción&uarr;</small>
                                      </Button>
                                      <Button 
                                        onClick={this.resetGroupCons}
                                        className="link-btn">
                                          <small>reset&darr;</small>
                                      </Button>
                                </div>
                            </div>
                        </div>
                        <Modal isOpen={this.state.add_group_cons} toggle={this.toggleGroupCons}>
                          <ModalHeader toggle={this.toggleGroupCons}>Incluir restricción</ModalHeader>
                          <ModalBody>
                            <div className="row m-2 justify-content-center">
                              <div className="col-6">
                                <Input
                                  id='type'
                                  type='select'
                                  placeholder="seleccionar..."
                                  value={this.state.group_id}
                                  onChange={(e)=>this.setState({
                                    group_id:e.target.value,
                                    value_id:""
                                  })}
                                >
                                  {[""].concat(unique_values(field_options, "label")).map((x,i)=>{
                                    return <option key={i} value={x}>{x}</option>;
                                  })}
                                </Input>
                              </div>
                              {this.state.group_id!=="" ?
                                <div className="col-6">
                                  <Input
                                    id='type'
                                    type='select'
                                    placeholder="seleccionar..."
                                    value={this.state.value_id}
                                    onChange={(e)=>this.setState({value_id:e.target.value})}
                                  >
                                    {[""].concat(field_options.find(k=>k.label==this.state.group_id).options).map((x,i)=>{
                                      return <option key={i} value={x}>{x}</option>;
                                    })}
                                  </Input>
                                </div>
                              : null
                              }
                            </div>
                            <div className="row mt-4 justify-content-center">
                              {this.state.adding_group_cons ?
                                <div className='col-6'>
                                  <CustomLoading msg="incluyendo restricción" />
                                </div>
                              : <div className="col-auto m-1">
                                  <Button 
                                    onClick={this.addGroupCons}
                                    className="btn-corp">
                                      Agregar
                                  </Button>
                                </div>
                              }
                            </div>
                            <div className="row mt-2 justify-content-center">
                              <div className="col m-3">
                                <Alert
                                  color='secondary'
                                  isOpen={this.state.msg_add!=='' && this.state.msg_add!==null} 
                                  toggle={()=>this.setState({msg_add:null})}>
                                    {this.state.msg_add}
                                </Alert>
                              </div>
                            </div>
                          </ModalBody>  
                        </Modal>

                    </div>
                </div>
            );
        }
    }
}

export default withRouter(connect(mapStateToProps)(Params));
